import { FetchHelper } from "shared-ts-utils-fetch";
import { IdentityUserDto } from "../IdentityUser";
import { LoginState } from "../LoginState";
import { SendChangePasswordEmailRequest } from "./SendChangePasswordEmailRequest";
import { ChangePasswordRequest } from "./ChangePasswordRequest";
import { ConfirmAccountRequest } from "./ConfirmAccountRequest";
import { LoginRequest } from "./LoginRequest";
import { AcceptInvitationRequest } from "./AcceptInvitationRequest";
import { InvitedIdentityUserDto } from "./InvitedIdentityUser";
import { GetInvitedUserResponse } from "./GetInvitedUserResponse";
import { ChangePasswordResponse } from "./ChangePasswordResponse";

export class IdentityDao {
  private readonly fetchHelper: FetchHelper;

  constructor() {
    this.fetchHelper = new FetchHelper({
      basePath: "/api/identity/",
    });
  }

  loginUsingCookies = async (request: LoginRequest): Promise<LoginState> => {
    const response = await this.fetchHelper
      .post("login?useCookies=true", request)
      .fetchAsResponse({ contentType: "application/json", ignoreError: true });
    if (response.ok) {
      return Promise.resolve("Success");
    } else {
      return Promise.resolve("UnauthorizedLoginAttempt");
    }
  };

  async confirmAccount(request: ConfirmAccountRequest): Promise<boolean> {
    const queryParams: Record<string, string> = {
      userId: request.userId,
      code: request.code,
    };
    try {
      await this.fetchHelper.get("confirm-email", queryParams).fetch();
      return true;
    } catch (e) {
      console.error("Error while confirming account: ", e);
      return false;
    }
  }

  logout(): Promise<void> {
    return this.fetchHelper.get("logout").fetch();
  }

  getInvitedUser<T extends InvitedIdentityUserDto>(
    token: string,
    userId: string
  ): Promise<GetInvitedUserResponse<T>> {
    return this.fetchHelper
      .get(`get-invited-user?token=${token}&userId=${userId}`)
      .fetchAsJson();
  }

  acceptInvitation(request: AcceptInvitationRequest): Promise<void> {
    return this.fetchHelper.post("accept-invitation", request).fetch();
  }

  getUser<T extends IdentityUserDto>(): Promise<T> {
    return this.fetchHelper.get("get-user").fetchAsJson();
  }
  sendChangePasswordEmail = async (
    request: SendChangePasswordEmailRequest
  ): Promise<void> => {
    return this.fetchHelper.get("send-change-password-email", request).fetch();
  };

  changePassword = async (
    request: ChangePasswordRequest
  ): Promise<ChangePasswordResponse> => {
    const response = await this.fetchHelper
      .post("change-password", request)
      .fetchAsResponse({ contentType: "application/json", ignoreError: true });

    if (response.status === 200) {
      return { result: "succeeded" };
    } else if (response.status === 406) {
      return { result: "invalid-token" };
    } else {
      const description = await response.text();
      return { result: "failed", description: description };
    }
  };
}
